import React from 'react';
import { AdditionalProps } from 'react-onclickoutside';

import DropdownComponent from '../../../Dropdown/Dropdown';
import { DropdownRendererParameters } from '../../../Autocomplete/components/Autocomplete';

import { Location } from '../../types';
import { useCityOptions } from '../../../LocationAutocomplete/hooks';
import LocationOptionsList from '../LocationOptionsList/LocationOptionsList';

interface OwnProps {
	onClickOutsideProps: AdditionalProps;
	hasInputData: boolean;
}

type Props = Partial<DropdownRendererParameters<Location>> & OwnProps;

const Dropdown: React.FunctionComponent<Props> = ({
	options,
	isOpen,

	onClose,
	onClickOutsideProps,
	onAdditionalButtonClick,
	...listProps
}) => {
	const { dropdownOptions, showAdditionalButton } = useCityOptions(options);

	return (
		<DropdownComponent
			{...onClickOutsideProps}
			keepMounted={true}
			isOpen={options.length && isOpen}
			onClose={onClose}
		>
			<LocationOptionsList
				options={dropdownOptions}
				showButton={showAdditionalButton}
				onButtonClick={onAdditionalButtonClick}
				{...listProps}
			/>
		</DropdownComponent>
	);
};

export default Dropdown;
